import { render } from "./Home.vue?vue&type=template&id=19f94a94&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=19f94a94&scoped=true&lang=scss"
import "./Home.vue?vue&type=style&index=1&id=19f94a94&scoped=true&lang=scss"
import "./Home.vue?vue&type=style&index=2&id=19f94a94&scoped=true&lang=scss"
import "./Home.vue?vue&type=style&index=3&id=19f94a94&scoped=true&lang=scss"

import exportComponent from "/home/travis/build/indochat/official-website/www.ecomm-cloud.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f94a94"]])

export default __exports__